import React from "react";
import VideoCards from "../components/VideoCards";
import HeroImage from "../components/HeroImage";
import HeroVideo1 from "../components/HeroVideo1";

import { cardsData } from "../utils/cardsData";
import backgroundimage from "../assets/images/service.png";
import video2 from "../assets/videos/service2.mp4";

function Services() {
  return (
    <div>
      <HeroImage
        backgroundImage={backgroundimage}
        heading="Onze Services"
        text="Wij bieden een groot scala aan services aan.Hieronder kunt u al onze diensten vinden.Heeft u een vraag over een van deze diensten of staat hetgeen wat u nodig heeft er niet tussen?"
      />
      <VideoCards cards={cardsData} cardsPerRow={4} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default Services;
